module.exports = __webpack_public_path__ + "static/img/003.cfbc5c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/awards/003.png
// module id = 5QWo
// module chunks = 0